var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 5V8.75M22.5 8.75L20 11.25M7.5 8.75L10 11.25",
    stroke: "#EDA92B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9015 21.5554L19.9137 21.628C20.057 22.4758 20.1286 22.8997 20.3511 23.2422C20.4174 23.3441 20.4929 23.4397 20.5766 23.5276C20.8582 23.8232 21.2536 23.9904 22.0445 24.3248C23.2329 24.8271 23.827 25.0784 24.397 24.9784C24.5644 24.949 24.7272 24.898 24.8816 24.8266C25.407 24.5836 25.7562 24.0324 26.4546 22.93C27.1831 21.7804 27.5472 21.2055 27.4951 20.5495C27.4834 20.4024 27.4451 20.216 27.398 20.0763C27.188 19.4526 26.6941 19.1142 25.7066 18.4372C19.021 13.8543 10.979 13.8543 4.29342 18.4372C3.30584 19.1142 2.81205 19.4526 2.60194 20.0763C2.55485 20.216 2.51662 20.4024 2.50492 20.5495C2.45271 21.2055 2.81692 21.7804 3.54535 22.93C4.2438 24.0324 4.59302 24.5836 5.11841 24.8266C5.2727 24.898 5.43557 24.949 5.60295 24.9784C6.17293 25.0784 6.76714 24.8271 7.95554 24.3248C8.74632 23.9904 9.14171 23.8232 9.42337 23.5276C9.50717 23.4397 9.58266 23.3441 9.64887 23.2422C9.87141 22.8997 9.94303 22.4758 10.0863 21.628L10.0985 21.5554C10.2464 20.6803 10.3203 20.2426 10.6446 19.8414C10.69 19.7853 10.7725 19.6961 10.825 19.6466C11.2003 19.2928 11.5314 19.2108 12.1936 19.0469C13.9774 18.6053 16.0226 18.6053 17.8064 19.0469C18.4686 19.2108 18.7997 19.2928 19.175 19.6466C19.2275 19.6961 19.31 19.7853 19.3554 19.8414C19.6796 20.2426 19.7536 20.6803 19.9015 21.5554Z",
    stroke: "#EDA92B",
    strokeWidth: 1.5,
    strokeLinecap: "square",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/call.17200af235747693f8abd780d16c7642.svg";
export { ForwardRef as ReactComponent };